
import Modal from "../../components/rebranding/modal/Modal.vue";
export default {
  components: {
    Modal,
  },

  head() {
    return {
      title: "تماس با ما - آبالون",
      meta: [
        {
          name: "description",
          content:
            " شما می توانید تمام روزهای هفته و به صورت شبانه روزی با ما در ارتباط باشید و سوالات یا مشکلات خود را از طریق راه های ارتباطی ذکر شده با متخصصان آبالون در میان بگذارید.",
        },
        {
          property: "og:description",
          content:
            " شما می توانید تمام روزهای هفته و به صورت شبانه روزی با ما در ارتباط باشید و سوالات یا مشکلات خود را از طریق راه های ارتباطی ذکر شده با متخصصان آبالون در میان بگذارید.",
        },
        {
          property: "og:site_name",
          content: " آبالون - ارائه دهنده سرور مجازی (VPS) و سرور ابری",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/contactus",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "تماس با ما - آبالون",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/contactus",
        },
        {
          name: "twitter:creator",
          content: "@themetrades",
        },
        {
          name: "twitter:title",
          content: "تماس با ما - آبالون",
        },
        {
          name: "twitter:description",
          content:
            " شما می توانید تمام روزهای هفته و به صورت شبانه روزی با ما در ارتباط باشید و سوالات یا مشکلات خود را از طریق راه های ارتباطی ذکر شده با متخصصان آبالون در میان بگذارید.",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/contactus",
        },
      ],
    };
  },
  data() {
    return {
      title: "آبالون: ارائه دهنده سرویس‌های ابری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      activeTab: 1,
      items: ["1 تا 5", "5 تا 20", "20  تا 50", " 50 به بالا"],
      valid: true,
      full_name: "",
      full_nameRules: [(v) => !!v || "نام و نام خانوادگی الزامی است"],
      first_name: "",
      first_nameRules: [(v) => !!v || "نام الزامی است"],
      last_name: "",
      last_nameRules: [(v) => !!v || "نام خانوادگی الزامی است"],
      mobile: "",
      mobileRules: [
        (v) => !!v || "شماره همراه الزامی است",
        (v) => /(\0)?9\d{9}/.test(v) || "شماره همراه باید معتبر باشد",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "ایمیل الزامی است",
        (v) => /.+@.+\..+/.test(v) || "ایمیل معتبر نمی باشد",
      ],
      company_name: "",
      companyRules: [(v) => !!v || "نام شرکت الزامی است"],
      semat: "",
      sematRules: [(v) => !!v || " سمت الزامی است"],
      showingIndex: 0,
      company_size: "",
      description: "",
      specialValuesCards: [
        {
          imageSrc: "Blog.webp",
          description: "به‌روز ترین خبرها و اخبار در آبالون",
          alt: "",
          title: "بلاگ آبالون",
          titleImg: "",
          link: "https://abalon.cloud/blog/",
          icon: "arrow-narrow-left.svg",
        },
        {
          imageSrc: "Help.webp",
          description: " راهنمای شیوه استفاده از محصولات",
          alt: "",
          title: "راهنمای محصولات",
          titleImg: "",
          link: "https://docs.abalon.cloud",
          icon: "arrow-narrow-left.svg",
        },
        {
          imageSrc: "Search.webp",
          description: "پاسخ‌های کوتاه برای پرسش‌های کاربران",
          alt: "",
          title: " پرسش‌های متداول",
          titleImg: "",
          titleImg: "",
          link: "https://panel.abalon.cloud/faq",
          icon: "arrow-narrow-left.svg",
        },
      ],
      socials: [
        {
          href: "https://t.me/Abalon_Cloud",
          img: "telegram.svg",
          alt: "تلگرام آبالون",
          title: "abalon-cloud-telegram",
        },
        {
          href: "https://www.youtube.com/channel/UCqX1yrUoTImlfQy8zF2bLww",
          img: "youtube.svg",
          alt: "یوتیوب آبالون",
          title: "abalon-cloud-youtube",
        },
        {
          href: "https://www.linkedin.com/company/abalon-cloud/",
          img: "linkedin.svg",
          alt: "لینکدین آبالون",
          title: "abalon-cloud-linkedin",
        },
        {
          href: "https://www.instagram.com/abalon_cloud?igsh=MTR5MTZhN3NrYjdjcA==",
          img: "instagram.svg",
          alt: "اینستاگرام آبالون",
          title: "abalon-cloud-instagram",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    openMap() {
      window.open("https://goo.gl/maps/tEuP4vR5xALSyPWd7");
    },
    async submitForm() {
      if (this.$refs.form.validate()) {
        let payload =
          this.activeTab == 1
            ? {
                full_name: this.full_name,
                email: this.email,
                mobile: this.mobile,
                company_name: this.company_name,
                company_size: this.company_size,
                description: this.description,
              }
            : {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                mobile: this.mobile,
                company_name: this.company_name,
                company_size: this.company_size,
                description: this.description,
              };

        let url =
          this.activeTab == 1
            ? "api/v1/contact/request/sales"
            : "api/v1/contact/request";

        try {
          let response = await this.$axios.$post(url, payload);
          if (response.success) {
            this.$toasted.success("درخواست شما با موفقیت ثبت شد!", {
              theme: "bubble",
              position: "top-right",
              duration: 1500,
            });
          }
        } catch (error) {
          this.$toasted.error("مشکلی در درخواست شما پیش آمد", {
            theme: "bubble",
            position: "top-right",
            duration: 1500,
          });
        }

        this.clear();
      }
    },

    clear() {
      this.first_name = "";
      this.last_name = "";
      this.full_name = "";
      this.mobile = "";
      this.email = "";
      this.company_size = "";
      this.company_name = "";
      this.reset();
      this.resetValidation();
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    handleClickCircle(index) {
      this.showingIndex = index;
    },
  },
};
